import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./assets/css/Comman.css";
import DigitalCard from "./components/DigitalCard";
import LandingPage from "./components/LandingPage";
import ServicesPage from "./components/ServicesPage";
import ContactPage from "./components/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/digital-card" element={<DigitalCard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
